import { getButtonVariantProps } from 'pricing-pages-ui-components/utils/buttonVariantUtils';
import SingleProductCTA from '../../../../features/purchaseMotions/components/SingleProductCTA';
import { PRODUCT_CARD } from '../../../../v2/constants/tracking/TrackingSources';
import SignupButton from '../../../common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductCardCTAs = ({
  apiName,
  screen,
  trackingSource = PRODUCT_CARD,
  skipInterstitialPage = false,
  isHubspotFree,
  purchaseMotions,
  location = 'MERCH_CARD'
}) => {
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  if (isHubspotFree) {
    return /*#__PURE__*/_jsx(SignupButton, {
      trackingSource: trackingSource,
      sourceId: trackingSource,
      nonMerchandiseIdProduct: apiName
    });
  }
  return purchaseMotions.map((purchaseMotion, index) => /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(SingleProductCTA, Object.assign({
      use: index === 0 ? 'primary' : 'secondary',
      purchaseMotion: purchaseMotion,
      apiName: apiName,
      screen: screen,
      trackingSource: trackingSource,
      purchaseMotionLocation: location,
      skipInterstitialPage: skipInterstitialPage
    }, ctaVariantProps))
  }, String(purchaseMotion)));
};